import axios from '../axios'
import Vue from 'vue'

export const getCurGroupNameData = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/enterprisename',
    method: 'get'
  })
}
// 获取管理员菜单
export const getAdminMenuData = () => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/userpriv',
    method: 'get'
  })
}

// 获取首页课程
export const getHomeCourseData = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/stat/groupcourselive',
    method: 'get'
  })
}
// 获取首页用户
export const getHomeTodayLive = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/stat/grouptodaylive',
    method: 'get'
  })
}
// 获取首页用户
export const getHomeUserData = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/stat/groupuser',
    method: 'get'
  })
}
// 获取首页今日直播
export const getHomeUserUvPv = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/stat/useruvpv',
    method: 'get'
  })
}
// 获取首页今日直播
export const getHomeTodayConsume = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/stat/todayconsume',
    method: 'get'
  })
}

export const  interCheck = () => {
  return axios({
    url: Vue.prototype.baseServer.homeServer + '/cms/intercheck',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/home.js